import React from 'react';

const FrFlag: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="84" height="56" viewBox="0 0 84 56" fill="none">
    <g clipPath="url(#clip0_47_1100)">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 -3.5H84V59.5H0V-3.5Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 -3.5H27.9956V59.5H0V-3.5Z" fill="#002654" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.0044 -3.5H84V59.5H56.0044V-3.5Z"
        fill="#CE1126"
      />
    </g>
    <defs>
      <clipPath id="clip0_47_1100">
        <rect width="84" height="63" fill="white" transform="translate(0 -3.5)" />
      </clipPath>
    </defs>
  </svg>
);
export default FrFlag;
